<template>
    <div class="wrapper" :class="{[`position-${position}`]:position}">
        <div class="toast" ref="toast">
            <div class="message">
                <slot v-if="!enableHtml"></slot>
                <div v-else v-html="$slots.default[0]"></div>
            </div>
            <span class="line" ref="line"></span>
            <span class="close" @click="onclickClose()" v-if="closeButton">{{closeButton.text}}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'g-toast',
    props: {
        autoClose: {
            type: [Boolean, Number],
            default: 3,
            validator(value) {
                return (
                    value === false ||
                    value === true ||
                    typeof value === 'number'
                )
            }
        },
        closeButton: {
            type: Object,
            default: () => {
                return {
                    text: '关闭',
                    callback: () => {}
                }
            }
        },
        enableHtml: {
            type: Boolean,
            default: false
        },
        position: {
            type: String,
            default: 'top',
            validator(value) {
                // return ['top', 'center', 'bottom'].includes(value)
                return ['top', 'center', 'bottom'].indexOf(value) > -1
            }
        }
    },
    mounted() {
        this.doAutoClose()
        this.setHeight()
    },
    methods: {
        doAutoClose() {
            if (this.autoClose) {
                setTimeout(() => {
                    this.close()
                }, this.autoClose * 1000)
            }
        },
        setHeight() {
            this.$nextTick(() => {
                this.$refs.line.style.height =
                    this.$refs.toast.getBoundingClientRect().height + 'px'
            })
        },
        close() {
            this.$el.remove()
            this.$destroy()
        },
        onclickClose() {
            this.close()
            if (
                this.closeButton &&
                typeof this.closeButton.callback === 'function'
            ) {
                this.closeButton.callback(this)
            }
        }
    }
}
</script>

<style scoped lang="scss">
$font-size: 14px;
$toast-height: 40px;
$toast-bg: rgba(0, 0, 0, 0.75);
@keyframes slide-up {
    0% {
        opacity: 0;
        transform: translateY(100%);
    }
    100% {
        opacity: 1;
        transform: translateY(0%);
    }
}
@keyframes slide-down {
    0% {
        opacity: 0;
        transform: translateY(-100%);
    }
    100% {
        opacity: 1;
        transform: translateY(0%);
    }
}
@keyframes fade-in {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
.wrapper {
    position: fixed;
    transform: translateX(-50%);
    left: 50%;
    &.position-top {
        top: 0;
        .toast {
            border-top-left-radius: 0;
            border-top-right-radius: 0;
            animation: slide-down 1s;
        }
    }
    &.position-center {
        top: 50%;
        transform: translateY(-50%);
        animation: fade-in 1s;
    }
    &.position-bottom {
        bottom: 0;
        .toast {
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
            animation: slide-up 1s;
        }
    }
}
.toast {
    font-size: $font-size;
    display: flex;
    align-items: center;
    background: $toast-bg;
    min-height: $toast-height;
    line-height: 1.8;
    color: #fff;
    box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.5);
    padding: 0 16px;
    border-radius: 4px;
    .message {
        padding: 8px 0;
    }
    .line {
        height: 100%;
        border-left: 1px solid #666;
        margin-left: 16px;
    }
    .close {
        padding-left: 16px;
        cursor: pointer;
    }
}
</style>